var map = {
	"./annotate.svg": 53574,
	"./annotation-marker.svg": 96936,
	"./arrow-left.svg": 81833,
	"./bounding-box.svg": 58770,
	"./bounding-cylinder.svg": 96108,
	"./check.svg": 90706,
	"./chevron-down.svg": 51728,
	"./chevron-left.svg": 57806,
	"./chevron-right.svg": 70356,
	"./chevron-up.svg": 87072,
	"./chronological-sort.svg": 7270,
	"./comment.svg": 45184,
	"./compare.svg": 84774,
	"./copy.svg": 47918,
	"./cursor.svg": 8713,
	"./door.svg": 5678,
	"./dots-horizontal.svg": 68548,
	"./dots-vertical.svg": 58863,
	"./download.svg": 39007,
	"./favorite.svg": 98416,
	"./favorites-filter.svg": 13940,
	"./filter.svg": 63817,
	"./grid.svg": 12637,
	"./group.svg": 7548,
	"./left-right-arrows.svg": 28040,
	"./link.svg": 27966,
	"./measure.svg": 56288,
	"./minus.svg": 4475,
	"./perspective.svg": 65050,
	"./pin.svg": 2807,
	"./planes.svg": 86301,
	"./plus.svg": 23189,
	"./search.svg": 79262,
	"./sort-asc.svg": 76300,
	"./sort-desc.svg": 14645,
	"./trash.svg": 10967,
	"./x.svg": 74118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;